import { AdminRoles } from './masterdata';
// If a drawer item has `featureIds` defined, it will only show that drawer item
// if the user has that feature enabled for them or their company.
export default {
  time: [
    {
      text: 'Time and Labor',
      items: [
        {
          featureIds: [6, 7],
          text: 'Time Card',
          icon: 'schedule',
          meta: null,
          anchor: {
            route: 'timecard',
            target: 'self',
          },
          items: null,
        },
        {
          featureIds: [18],
          text: 'Time Off',
          icon: 'weekend',
          meta: null,
          anchor: {
            route: 'timeoff',
            target: 'self',
          },
          items: null,
        },
        {
          featureIds: [11, 19],
          text: 'Schedule',
          icon: 'event_note',
          meta: null,
          anchor: {
            route: 'schedule',
            target: 'self',
          },
          items: null,
        },
        {
          featureIds: [43],
          text: 'Reports',
          icon: 'insert_drive_file',
          meta: 'open_in_new',
          anchor: {
            route: 'time-reports',
            target: 'blank',
          },
          items: null,
          roles: [...AdminRoles, 'Manager'],
        },
        {
          featureIds: [43],
          text: 'Time Card  Day View',
          icon: 'view_day',
          meta: 'open_in_new',
          anchor: {
            route: 'timecard-daily',
            target: 'blank',
          },
          items: null,
          roles: [...AdminRoles, 'Manager'],
        },
        {
          featureIds: [6, 7],
          key: '508af59b-93f4-4b58-9a3a-6f78e20d3637',
          text: 'Payroll Review',
          icon: 'view_day',
          meta: null,
          anchor: {
            route: 'timeui',
            target: 'self',
          },
          items: null,
          roles: AdminRoles,
        },
      ],
    },
  ],
  people: [
    {
      text: 'People',
      items: [
        {
          text: 'Employees',
          order: 0,
          meta: null,
          anchor: {
            route: 'employees-list',
            target: 'self',
          },
          items: null,
        },
        {
          featureIds: [30],
          text: 'Organization Chart',
          anchor: {
            route: 'organization-chart',
            target: 'self',
          },
          items: null,
        },
        {
          featureIds: [32],
          text: 'Employee Invites',
          anchor: {
            route: 'employee-invites',
            target: 'self',
          },
          items: null,
          roles: AdminRoles,
        },
        {
          text: 'Bulk Add and Edit',
          anchor: {
            route: 'bulk-add-and-edit',
            target: 'self',
          },
          items: null,
          roles: AdminRoles,
        },
      ],
    },
  ],
  hr: [
    {
      text: 'HR',
      items: [
        {
          text: 'Dashboard',
          icon: 'dashboard',
          meta: null,
          anchor: '',
          items: null,
        },
        {
          text: 'New Hires',
          icon: 'person_add_alt_1',
          meta: null,
          anchor: '',
          items: null,
        },
        {
          text: 'Benefits',
          icon: 'local_pharmacy',
          meta: null,
          anchor: '',
          items: null,
        },
        {
          text: 'Employees',
          icon: 'person',
          meta: null,
          anchor: '',
          items: null,
        },
        {
          text: 'Custom Fields',
          icon: 'dynamic_feed',
          meta: null,
          anchor: '',
          items: null,
        },
        {
          text: 'Workflows/Tasks',
          icon: 'work',
          meta: null,
          anchor: '',
          items: null,
        },
        {
          text: 'Alerts',
          icon: 'notifications',
          meta: null,
          anchor: '',
          items: null,
        },
        {
          text: 'Reporting',
          icon: 'insert_drive_file',
          meta: null,
          anchor: '',
          items: null,
        },
      ],
    },
  ],
  admin: [
    {
      text: 'Management & Configurations',
      items: [
        {
          text: 'Company',
          order: 0,
          icon: 'business',
          meta: null,
          anchor: '',
          items: [
            {
              featureIds: [8],
              text: 'Company Info',
              order: 0,
              anchor: {
                route: 'company-info',
                target: 'self',
              },
              roles: AdminRoles,
            },
            {
              text: 'Organization Setup',
              order: 1,
              anchor: {
                route: 'organization-setup',
                target: 'self',
              },
            },
            {
              text: 'Employee Types',
              order: 2,
              anchor: {
                route: 'employee-types',
                target: 'self',
              },
            },
            {
              featureIds: [9],
              text: 'Deductions',
              order: 3,
              anchor: {
                route: 'deductions',
                target: 'self',
              },
            },
            {
              featureIds: [45],
              text: 'Account Information',
              order: 99,
              anchor: {
                route: 'billing',
                target: 'self',
              },
            },
          ],
        },
        {
          text: 'Timekeeping',
          order: 1,
          icon: 'schedule',
          meta: null,
          anchor: '',
          items: [
            {
              text: 'Time Policies',
              anchor: '',
              items: [
                {
                  featureIds: [27, 28],
                  text: 'Time Off',
                  anchor: {
                    route: 'settings-timeoff',
                    target: 'self',
                  },
                },
                {
                  featureIds: [28],
                  text: 'Accruals',
                  anchor: {
                    route: 'accruals',
                    target: 'self',
                  },
                },
                {
                  text: 'Overtime',
                  anchor: {
                    route: 'settings-overtime',
                    target: 'self',
                  },
                },
                {
                  text: 'Holidays',
                  featureIds: [6],
                  anchor: {
                    route: 'settings-holidays',
                    target: 'self',
                  },
                },
                {
                  text: 'Holidays',
                  featureIds: [7],
                  meta: 'open_in_new',
                  anchor: {
                    route: 'settings-holidays-advanced',
                    target: 'blank',
                  },
                },
                {
                  featureIds: [25],
                  text: 'Breaks and Meals',
                  anchor: {
                    route: 'settings-break-and-meals',
                    target: 'self',
                  },
                },
                {
                  text: 'Time Card Settings',
                  anchor: {
                    route: 'settings-timecard',
                    target: 'self',
                  },
                },
                {
                  text: 'Punch Categories',
                  featureIds: [7],
                  anchor: {
                    route: 'punch-categories',
                    target: 'self',
                  },
                },
              ],
            },
            {
              featureIds: [6, 7, 29],
              text: 'Clock Management',
              anchor: '',
              items: [
                {
                  text: 'Clock Options',
                  anchor: {
                    route: 'settings-timeclock',
                    target: 'self',
                  },
                  items: null,
                },
                {
                  featureIds: [7],
                  text: 'Clock Prompts',
                  meta: 'open_in_new',
                  anchor: {
                    route: 'clock-prompts',
                    target: 'blank',
                  },
                  roles: [...AdminRoles],
                },
                {
                  featureIds: [29],
                  text: 'Biometrics',
                  meta: 'open_in_new',
                  anchor: {
                    route: 'biometrics-management',
                    target: 'blank',
                  },
                  items: null,
                },
                {
                  featureIds: [29],
                  text: 'Hardware Clocks',
                  anchor: {
                    route: 'hardware-clocks',
                    target: 'self',
                  },
                  items: null,
                },
                {
                  excludedFeatureIds: [39],
                  text: 'Unmatched Punches',
                  meta: 'open_in_new',
                  anchor: {
                    route: 'unmatched-punches',
                    target: 'blank',
                  },
                  roles: [...AdminRoles, 'Manager'],
                },
              ],
            },
            {
              featureIds: [7],
              text: 'Geofence',
              anchor: {
                route: 'geofence',
                target: 'self',
              },
              items: null,
              roles: ['SiteAdmin'],
            },
            {
              featureIds: [7],
              text: 'Groups',
              meta: 'open_in_new',
              anchor: {
                route: 'groups',
                target: 'blank',
              },
              items: null,
            },
            {
              featureIds: [11],
              text: 'Scheduling',
              anchor: {
                route: 'settings-schedule',
                target: 'self',
              },
            },
          ],
        },
        {
          text: 'Payroll',
          order: 2,
          icon: 'monetization_on',
          meta: null,
          anchor: '',
          items: [
            {
              text: 'Finalize Pay Period',
              meta: null,
              anchor: {
                route: 'finalize-pay-period',
                target: 'self',
              },
              items: null,
            },
            {
              text: 'Payroll Export',
              meta: 'open_in_new',
              anchor: {
                route: 'payroll-export',
                target: 'blank',
              },
              items: null,
            },
          ],
        },
        {
          featureIds: [16],
          text: 'Communications',
          order: 3,
          icon: 'communications',
          meta: null,
          anchor: '',
          items: [
            {
              featureIds: [16],
              text: 'Company Messages',
              meta: null,
              anchor: {
                route: 'company-messages',
                target: 'self',
              },
              items: null,
            },
          ],
        },
        {
          featureIds: [46],
          text: 'File Cabinet',
          order: 4,
          icon: 'communications',
          meta: null,
          anchor: '',
          items: [
            {
              featureIds: [46],
              text: 'Company Docs & Links',
              meta: null,
              anchor: {
                route: 'company-docs-links',
                target: 'self',
              },
              items: null,
            },
          ],
        },
        {
          text: 'Integrations',
          order: 5,
          icon: 'integration_instructions',
          meta: null,
          anchor: {
            route: 'integrations',
            target: 'self',
          },
          items: [],
        },
        {
          text: 'Suggestion Box',
          order: 5,
          meta: 'open_in_new',
          anchor: {
            route: 'suggestion-box',
            target: 'blank',
          },
          items: null,
        },
      ],
    },
  ],
};
